export default "__VITE_ASSET__CCrHNXyz__"